import React, { useState } from 'react';
import styled from 'styled-components';
import { func, string, object, number, any } from 'prop-types';
import { useParams } from 'react-router-dom';
import { getI18nLanguageCode } from '../../../../i18n';
import { stringify } from 'query-string';
import { format } from 'date-fns';

// Components
import { Modal, LoadingSpinner } from 'wg-fe-ui';
import useSessionId from '../../../flows/src/hooks/useSessionId';

const ReportModal = ({
  setShowModal,
  quoteId,
  batchId,
  insuranceCompany,
  insuranceType,
  brokerDistribution,
  clickTime,
  flow,
  rawResponse,
  me,
  ...otherProps
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const { sessionId } = useParams();
  const sessionIdParam = useSessionId();

  const getClickupUrl = () => {
    const date = format(new Date(), 'dd/MM/yyyy');
    const sessionRecordingUrl = sessionStorage.getItem('sessionRecordingUrl');

    let clickUpId;

    // Each clickUpId refers to a different form, which has the correct language
    switch (getI18nLanguageCode()) {
      case 'nl':
        clickUpId = '22k7n-4677/R52SWLFAE1HRSBKNKO';
        break;
      case 'en':
        clickUpId = '22k7n-4691/Q041U67JCW6ALIVTSC';
        break;
      case 'fr':
        clickUpId = '22k7n-4684/7SOOBT3OS4R2TOCBKL';
        break;
      default:
        clickUpId = '22k7n-4691/Q041U67JCW6ALIVTSC';
        break;
    }

    const queryParamsObject = {
      'Task name': `[${date}] Quotes Feedback - ${brokerDistribution?.name} - ${insuranceCompany} - ${insuranceType}`,
      Client: brokerDistribution?.name,
      'Client Email': me?.email,
      Logrocket: sessionRecordingUrl?.split('?')[0] + `?t=${clickTime}`,
      PostHog: sessionStorage.getItem('posthog_session_url'),
      quote_id: quoteId,
      session_id: sessionId || sessionIdParam,
      batch_id: batchId,
      'Insurance Company': insuranceCompany,
      'Insurance Type': insuranceType,
      Flow: flow,
      'Broker Plan': me?.plan,
      Language: getI18nLanguageCode().toUpperCase(),
      'Distribution Id': brokerDistribution?.id,
      'Raw Response': rawResponse
        ? JSON.stringify(rawResponse)
        : 'No error logged in the raw response',
    };

    let url = `https://forms.clickup.com/f/${clickUpId}?${stringify(
      queryParamsObject,
      { sort: false },
    )}`;

    if (url.length > 2000) {
      url = url.substring(0, 1997);
      url += '_CUT';
    }
    return url;
  };

  return (
    <StyledModal
      setShowModal={(show) => {
        setShowModal(show);
        if (!show) setIsLoading(true);
      }}
      canClose
      large
      {...otherProps}
    >
      {isLoading && (
        <LoadingWrapper>
          <LoadingSpinner />
        </LoadingWrapper>
      )}
      <Frame
        data-test-id="ProF_ReportModal_Frame"
        title="report"
        className="clickup-embed clickup-dynamic-height"
        src={getClickupUrl()}
        frameBorder="0"
        onLoad={() => setIsLoading(false)}
      />
      <script
        async
        src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
      ></script>
    </StyledModal>
  );
};

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Frame = styled.iframe`
  background: transparent;
  width: 100%;
  height: 100%;
`;

const StyledModal = styled(Modal)`
  > div {
    height: 100%;
    padding: 0;
  }
  border: none;
  height: 900px;
  overflow-y: hidden;
`;

ReportModal.propTypes = {
  setShowModal: func.isRequired,
  brokerData: object.isRequired,
  quoteId: string.isRequired,
  batchId: string.isRequired,
  insuranceCompany: string.isRequired,
  insuranceType: string.isRequired,
  brokerDistribution: object.isRequired,
  flow: string.isRequired,
  clickTime: number.isRequired,
  rawResponse: any,
  me: object,
};

export default ReportModal;
